import { render, staticRenderFns } from "./JgBespokeNovibet.vue?vue&type=template&id=443089ef&scoped=true&"
import script from "./JgBespokeNovibet.vue?vue&type=script&lang=ts&"
export * from "./JgBespokeNovibet.vue?vue&type=script&lang=ts&"
import style0 from "./JgBespokeNovibet.vue?vue&type=style&index=0&id=443089ef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443089ef",
  null
  
)

export default component.exports